import React, { useEffect, useState } from "react";
import { AiOutlineDashboard, AiOutlineSetting, AiOutlineFileText, AiOutlineUsergroupAdd } from "react-icons/ai";
import { RiUserLine, RiBriefcaseLine, RiLineChartLine } from "react-icons/ri";
import { BiLogOut, BiSupport } from "react-icons/bi";
import { FaChartLine, FaUsers, FaWallet } from "react-icons/fa";
import { MdOutlineManageAccounts, MdOutlineNotifications } from "react-icons/md";
import logo from "../images/LogoDashboard.png";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ACTIVETAB, EMPTY, Logout } from "../Actions/actions";
import { useDispatch } from "react-redux";
import Loader from "../Components/Loader/Loader";
import { CiWallet } from "react-icons/ci";
import { SiSubstack } from "react-icons/si";
import { BsWallet } from "react-icons/bs";
import { IoNotificationsOutline, IoPricetagsOutline } from "react-icons/io5";
import { TbUsersGroup } from "react-icons/tb";
import { IoIosNotifications, IoIosNotificationsOutline } from "react-icons/io";

const Sidebar = ({ setIsSidebarOpen, isSidebarOpen }) => {
  const dispatch = useDispatch();
  const { role, logoutLoader, loginData, activeTab, Privilages } = useSelector((state) => state.userReducer);
  const navigate = useNavigate();

  const [sidebarItems, setsidebarItems] = useState([]);
  useEffect(() => {
    let items = [
      {
        name: "Dashboard",
        icon: <AiOutlineDashboard />,
        path: "/dashboard",
        roles: ["Client", "Admin", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Lead Management",
        icon: <TbUsersGroup />,
        path: "/lead-management",
        roles: ["Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Client Management",
        icon: <AiOutlineUsergroupAdd />,
        path: "/client-management",
        roles: ["Admin"],
        enable: true,
      },
      {
        name: "Pipeline Management",
        icon: <RiLineChartLine />,
        path: "/pipeline-management",
        roles: ["Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "User Management",
        icon: <RiUserLine />,
        path: "/user-management",
        roles: ["Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Role Management",
        icon: <MdOutlineManageAccounts />,
        path: "/role-management",
        roles: ["Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Assets Management",
        icon: <RiBriefcaseLine />,
        path: "/assets-management",
        roles: ["Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Report Management",
        icon: <AiOutlineFileText />,
        path: "/report-management",
        roles: ["Admin", "Employee", "Client"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Transactions",
        icon: <BsWallet />,
        path: "/transactions",
        roles: ["Admin"],
        enable: true,
      },
      {
        name: "Subscription Requests",
        icon: <IoPricetagsOutline />,
        path: "/subscription-requests",
        roles: ["Admin"],
        enable: true,
      },
      {
        name: "Notifications",
        icon: <IoNotificationsOutline />,
        path: "/notifications",
        roles: ["Admin", "Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Support",
        icon: <BiSupport />,
        path: "/support",
        roles: ["Admin", "Client", "Employee"],
        enable: loginData?.clientData ? loginData?.clientData?.paymentStatus === "paid" : true,
      },
      {
        name: "Settings",
        icon: <AiOutlineSetting />,
        path: "/settings",
        roles: ["Admin", "Client", "Employee"],
        enable: true,
      },
    ];

    const updatedItems = items.map((item) => {
      const matchedPrivilege = Privilages?.find(
        (priv) => item.name !== "Dashboard" && priv.feature === item.name && priv.accessLevel === "Restricted"
      );
      return {
        ...item,
        hidden: matchedPrivilege ? true : false,
      };
    });

    setsidebarItems(updatedItems);
  }, [loginData]);

  console.log(activeTab, "activetab");
  return (
    <aside className="w-76 font-public  bg-white py-4 shadow-md  top-0 h-full overflow-auto hide-scrollbar">
      <div
        onClick={() => {
          navigate("/dashboard");
          dispatch({
            type: ACTIVETAB,
            payload: "Dashboard",
          });
        }}
        className="flex items-center justify-center mb-6 px-4"
      >
        <img src={logo} alt="Logo" className="w-36 h-12" />
      </div>
      <nav className="px-4">
        {sidebarItems
          .filter((item) => item.roles.includes(role))
          .map(
            (item, index) =>
              item?.hidden == false && (
                <Link
                  key={index}
                  to={item.enable ? item.path : null}
                  className={`flex items-center py-3 px-4 mb-1 rounded-md w-full transition duration-200 ${
                    item.enable
                      ? activeTab === item.name
                        ? "bg-[#361D32] text-white"
                        : "text-gray-700 hover:bg-gray-200"
                      : "bg-zinc-100 text-gray-500 disabled:cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (item.enable == true) {
                      dispatch({
                        type: ACTIVETAB,
                        payload: item.name,
                      });
                    }
                  }}
                >
                  <span className="mr-4 text-xl">{item.icon}</span>
                  <span>{item.name}</span>
                </Link>
              )
          )}
        {logoutLoader ? (
          <Loader />
        ) : (
          <div
            className={`flex items-center py-3 px-4 mb-2 rounded-md w-full transition duration-200 
                 text-gray-700 hover:bg-gray-200 cursor-pointer`}
            onClick={() => {
              dispatch(
                Logout(loginData?.accessToken, () => {
                  dispatch({
                    type: ACTIVETAB,
                    payload: "Dashboard",
                  });
                  navigate("/");
                  setIsSidebarOpen(false);
                })
              );
              navigate("/");
            }}
          >
            <span className="mr-4 text-xl">
              <BiLogOut />
            </span>
            <span>Logout</span>
          </div>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
